// Turn any thrown/axios error into a message that is safe to show a user.
// Prefers a message the server intentionally sent (those are written for
// humans), then handles the common no-network case, and otherwise returns a
// friendly generic — never a raw JS/technical string like
// "state.products.map is not a function" or "Request failed with status 500".
export default function humanError(err, fallback = "Something went wrong. Please try again.") {
  const server = err?.response?.data?.message || err?.response?.data?.error;
  if (server && typeof server === "string") return server;

  const status = err?.response?.status;
  if (status === 401) return "Please sign in to continue.";
  if (status === 403) return "You don't have permission to do that.";
  if (status === 404) return "We couldn't find what you were looking for.";
  if (status === 413) return "That file is too large. Please choose a smaller one.";
  if (status >= 500) return "Our server ran into a problem. Please try again in a moment.";

  if (err?.code === "ERR_NETWORK" || err?.message === "Network Error") {
    return "Can't reach the server. Please check your internet connection and try again.";
  }
  return fallback;
}
